// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1Rftk","savePackageButton":"ClientWallet_savePackageButton__12ubi"};